import { Controller } from "@hotwired/stimulus"
import AutoSubmit from "@stimulus-components/auto-submit"

// Connects to data-controller="auto-submit"
export default class extends AutoSubmit {}
